import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const GuideCardWrapper = styled.div`
  padding: 10px 0px;

  @media (max-width: ${TabletWidth}px) {
    padding: 0px;
  }
`;

export const GuideCardContainer = styled.div`
  min-width: 323px;
  background-color: ${getColor('BEIGE_2')};
  border-radius: 12px;
  margin: 0px 25px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  @media (max-width: ${TabletWidth}px) {
    height: 100%;
    border-radius: 32px;
    margin: 0px 12px;
    box-shadow: none;
    min-width: 238px;
  }
`;

export const GuideCardAvatarSection = styled.div`
  background-color: ${getColor('BEIGE_20')};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  height: 215px;
  text-align: center;

  @media (max-width: ${TabletWidth}px) {
    height: 140px;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
  }
`;

export const GuideCardAvatar = styled.img`
  height: 100%;
  width: auto;
`;

export const GuideCardContent = styled.div`
  max-width: 350px;
  margin: auto;
  padding-bottom: 34px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media (max-width: ${TabletWidth}px) {
    padding-bottom: 16px;
  }
`;

export const GuideCardContentTexts = styled.div`
  padding: 24px 14px 18px;
  flex-grow: 1;

  @media (max-width: ${TabletWidth}px) {
    padding: 16px 10px;
  }
`;

export const GuideCardLabelWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const GuideCardLabel = styled.label`
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  color: ${getColor('BEIGE_70')};
`;
export const GuideCardLabelIcon = styled.img`
  margin-right: 8px;
`;

export const GuideCardName = styled.p`
  font-size: 28px;
  font-weight: 600;
  line-height: 44px;
  text-align: center;
  color: ${getColor('OLD_GRAY_80')};
  margin-bottom: 6px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const GuideCardDescription = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: ${getColor('GRAY_50')};
  white-space: pre-line;
  margin-bottom: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* limits the text to 2 lines */
  -webkit-box-orient: vertical;

  @media (max-width: ${TabletWidth}px) {
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  }
`;

export const GuideCardNumbers = styled.div`
  display: flex;
`;
export const GuideCardNumberColumn = styled.div<{ isMiddle?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 2px 0px;
  margin: 4px 0px;
  flex-grow: 1;

  ${({ isMiddle }) =>
    isMiddle &&
    `
    border-left: 1px solid ${getColor('GRAY_50')};
    border-right: 1px solid ${getColor('GRAY_50')};
  `};
`;

export const GuideCardNumberColumnValueWrapper = styled.div`
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GuideCardNumberColumnValue = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${getColor('OLD_GRAY_80')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const GuideCardNumberColumnStar = styled.img`
  margin-left: 2px;
  height: 16px;
  width: 16px;

  @media (max-width: ${TabletWidth}px) {
    height: 11px;
    width: 11px;
  }
`;
export const GuideCardNumberColumnText = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: ${getColor('GRAY_50')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
`;

export const GuideCardAudioButtonWrapper = styled.div`
  display: flex;
`;

export const GuideCardAudioButton = styled.button`
  cursor: pointer;
  transition: none;
  padding: 10px 8px;
  text-align: center;
  margin: auto;
  width: 265px;
  background-color: ${getColor('BEIGE_2')};
  border: 1px solid ${getColor('OLD_GRAY_80')};
  border-radius: 50px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: left;
  height: 50px;
  position: relative;

  @media (max-width: ${TabletWidth}px) {
    font-size: 12px;
    line-height: 18px;
    width: 180px;
    margin: auto;
    height: 35px;
  }
`;

export const GuideCardAudioButtonIcon = styled.img`
  position: absolute;
  left: 10px;
  top: 50%;
  height: 32px;
  width: 32px;
  transform: translateY(-50%);

  @media (max-width: ${TabletWidth}px) {
    height: 22px;
    width: 22px;
  }
`;
export const GuideCardAudioButtonText = styled.span`
  margin-left: 30px;
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  font-family: Poppins;
  color: ${getColor('OLD_GRAY_80')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 12px;
    line-height: 18px;
    line-height: 18px;
  }
`;
